import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'material-order-navigation',
    templateUrl: './material-order-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialOrderNavigationComponent {
  constructor() {
  }
}
